<nz-page-header [nzTitle]="content?.itemId"></nz-page-header>
<nz-divider nzDashed></nz-divider>
